import CutwiseAPIClient from '@/common/network/CutwiseAPIClient';
import { METHOD_POST } from '@/common/network/CutwiseAPIClient';
import { PreviewRequest } from '@/media/types/PreviewRequest';
import { PreviewResponse } from '@/media/types/PreviewResponse';

export const PATH_PREVIEW = 'api/preview';

class PreviewAPI {
  async fetchPreview(data: PreviewRequest[]): Promise<PreviewResponse[]> {
    const qb = CutwiseAPIClient.createQueryBuilder().method(METHOD_POST).path(PATH_PREVIEW).body(data);

    const query = qb.getQuery();
    const res = await CutwiseAPIClient.sendQuery<PreviewResponse[]>(query);

    return res.content;
  }
}

export default PreviewAPI;
